import React, { useEffect, useState } from "react";
import { mainApi } from "../providers/api";
import Loading from "../components/Loading";
import SignItem from "./components/Sign";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
const Search = () => {
  const { text } = useParams();
  console.log("🚀 ~ Search ~ text:", text);
  const [data, setdata] = useState();
  const [loading, setloading] = useState(false);
  const [offset, setoffset] = useState(0);
  const { t } = useTranslation();
  useEffect(() => {
    const fetch = async () => {
      try {
        setloading(true);

        const result = await mainApi({
          url: `/service/sign`,
          method: `POST`,
          auth: {
            username: "hsct",
            password:
              "769a9a905bbd4046903581605db75cad20fe84c70868d9874a628f09347c47df",
          },
          data: {
            find: {
              name: { $regex: text, $options: "i" },
            },
            offset: offset,
            limit: 20,
            sort: {
              sequence: -1,
            },
          },
        });

        setdata(result.data.items);
        setloading(false);
      } catch (err) {
        setloading(false);
        console.log("err", err);
      }
    };

    fetch();
  }, [text]);
  return (
    <div className="flex p-4 pb-28">
      <div className="flex flex-wrap w-full justify-center md:justify-start">
        {loading ? (
          <Loading width="w-16" />
        ) : data?.length > 0 ? (
          data?.map((row, index) => {
            return <SignItem key={index} data={row} />;
          })
        ) : (
          <div className="flex w-full justify-center items-center h-64">
            <div className="text-gray-400">{t("empty")}</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Search;
